import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import * as styles from './ChatMessageContextMenu.css';
import { TChatMessageMenuItem } from '../../types/chatMessageMenuItem';

type TChatMessageContextMenuProps = {
  menuItems: TChatMessageMenuItem[];
  onCloseContextMenu(): void;
  chatId: string;
  messageId: string;
  top: number;
  left: number;
};

export const ChatMessageContextMenu: React.FC<TChatMessageContextMenuProps> = ({
  menuItems,
  chatId,
  messageId,
  onCloseContextMenu,
  top,
  left,
}) => {
  const [adjustedPosition, setAdjustedPosition] = React.useState({ left: 0, top: 0 });

  const menuRef = React.useCallback(
    (node: HTMLUListElement) => {
      if (node !== null) {
        const { offsetWidth, offsetHeight } = node;
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        /* istanbul ignore next */
        const adjustedLeft =
          left + offsetWidth > windowWidth && (left - offsetWidth > 0 || (left - offsetWidth) / offsetWidth > -0.4)
            ? left - offsetWidth
            : left;
        const adjustedTop = top + offsetHeight > windowHeight ? /* istanbul ignore next */ top - offsetHeight : top;
        setAdjustedPosition({ left: adjustedLeft, top: adjustedTop });
      }
    },
    [left, top],
  );

  const items = React.useMemo(
    () =>
      menuItems.map(({ title, color, icon, handler, dataTestId }, index) => (
        <li
          key={index}
          data-name="ChatMessageContextMenuItem"
          data-testid={dataTestId}
          className={styles['item']}
          style={{ color }}
          onClick={() => {
            handler(chatId, messageId);
            onCloseContextMenu();
          }}
        >
          <UIText1 color="current_color">{title}</UIText1>
          {icon}
        </li>
      )),
    [menuItems, chatId, messageId, onCloseContextMenu],
  );

  return ReactDOM.createPortal(
    <ul data-name="ChatMessageContextMenu" ref={menuRef} className={styles['menu']} style={adjustedPosition}>
      {items}
    </ul>,
    document.body,
  );
};
